// const REACT_APP_BASE_URL = 'http://localhost:8000/api/'
// const REACT_APP_BASE_URL = 'http://15.206.34.95.nip.io/api/';
// export default REACT_APP_BASE_URL
// new code for env file 
const REACT_APP_BASE_URL = process.env.REACT_APP_BASE_URL;
console.log(REACT_APP_BASE_URL);

export default REACT_APP_BASE_URL;
